export const DOCUMENTS_FEATURES = {
  moduleKey: 'documents',
  features: ['documents.templates', 'documents.templates.edit', 'documents.generate'] as const,
  featureMeta: {
    'documents.templates': {
      name: 'Document templates',
      translations: { name: { de: 'Dokumentvorlagen', en: 'Document templates', fr: 'Modèles de documents', it: 'Modelli di documenti' } },
    },
    'documents.templates.edit': {
      name: 'Edit document templates',
      translations: {
        name: {
          de: 'Dokumentvorlagen bearbeiten',
          en: 'Edit document templates',
          fr: 'Modifier les modèles de documents',
          it: 'Modificare i modelli di documenti',
        },
      },
    },
    'documents.generate': {
      name: 'Generate documents',
      translations: {
        name: { de: 'Dokumente generieren', en: 'Generate documents', fr: 'Générer des documents', it: 'Generare documenti' },
      },
    },
  },
} as const;
